import { Swiper, Navigation, Pagination } from 'swiper/js/swiper.esm.js';


export default class InteractiveHeroSlider {
  constructor(featuredSlider) {
    Swiper.use([Navigation, Pagination]);

    let sliderContainer = featuredSlider.parentElement.parentElement;
    let paginationElement = sliderContainer.querySelector('.swiper-pagination');
    let prevButton = sliderContainer.querySelector('.swiper-button-prev');
    let nextButton = sliderContainer.querySelector('.swiper-button-next');

    var mySwiper = new Swiper(featuredSlider, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      slidesOffsetAfter: 40,
      pagination: {
        el: paginationElement,
        type: 'bullets',
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      breakpoints: {
        // When window width is >= 768 (medium screen)
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3,
          slidesOffsetAfter: 0
        },
      },
    });

    // special functionality for mobile click to reveal description copy and then on a second click, link to content;

    const cards = document.querySelectorAll('.featured-slide__link');

    function clickChecker(e, card, index, cards) {
      if( window.innerWidth < 768 ) {
        if (card.classList.contains('--show-overlay')) {
          return
        } else if (!card.classList.contains('--show-overlay')) {
          e.preventDefault();
          let clickedLink = e.currentTarget;
          card.classList.add('--show-overlay');
          cards.forEach(function(card2) {
            if(card2.dataset.id !== clickedLink.dataset.id) {
              card2.classList.remove('--show-overlay');
            }
          });
        }
      }
    }

    cards.forEach((card, index, cards) => {
      card.dataset.id = index;
      card.addEventListener('click', (e) => {
        clickChecker(e, card, index, cards);
      });
    })


  }
}
